import './Kpisearch.scss'
import SearchIcon from '@mui/icons-material/Search';
import { Input, InputAdornment, IconButton, styled, InputBase, alpha } from "@mui/material";

export const KPISearch = ({ setSearchData, searchList }) => {

    const Search = styled('div')(({ theme }) => ({
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: alpha(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: alpha(theme.palette.common.white, 0.25),
        },
        marginLeft: 0,
        width: '100%',
    }));

    const StyledInputBase = styled(InputBase)(({ theme }) => ({
        color: 'black',
        borderRadius: '20px',
        backgroundColor: ' #F0F3F6',
        '& .MuiInputBase-input': {
            // vertical padding + font size from searchIcon
            paddingLeft: `calc(1em + ${theme.spacing(1)})`,
            transition: theme.transitions.create('width'),  
            width: '100%',
           
        },
    }));

    return (
        <Input
            sx={{ height: '38px', width: "50%", borderRadius: '20px', backgroundColor: '#ffffff', border: 'none', color: 'rgba(0, 0, 0, 0.65)', fontSize: '17px' }}
            placeholder='Search'
            className='searchBox'
            type='text'
            onChange={(e) => {
                searchList();
                setSearchData(e.target.value);
            }}
            endAdornment={
                <InputAdornment position="end">
                    <IconButton
                        aria-label="toggle password visibility"
                        onClick={searchList}
                        edge="end"
                        style={{ color: '#2A4D69' }}
                    >
                        <SearchIcon/>
                    </IconButton>
                </InputAdornment>
            }
        />
    )
}